export default "__VITE_ASSET__2a763c5f__"